<script setup lang="ts">
import type { IGameCategory } from '~/interfaces/dto/games/response';
import ExternalIcon from '../design-system/icons/ExternalIcon.vue';

interface ICarouselProps {
  title: string;
  alias?: string;
  games: IGameCategory[];
  route?: string;
  displayShowAll?: boolean;
  verticalNavigation?: boolean;
  showTitle?: boolean;
  verticalTile?: boolean;
  totalGames?: number;
}

const props = withDefaults(defineProps<ICarouselProps>(), {
  title: '',
  route: '',
  displayShowAll: true,
  verticalNavigation: false,
  verticalTile: false,
  alias: '',
  totalGames: 0,
  games: null,
});

const refreshKey = computed(
  () => `${props.title}-${props.games?.length}-${props.alias}`,
);

const image = useImagePath;
</script>
<template>
  <UserInterfaceGenericCarousel
    :id="props.alias"
    :key="refreshKey"
    :title="props.title"
    display-show-all
    vertical-navigation
    :route="props.route"
  >
    <template #icon>
      <slot name="icon" />
      <ExternalIcon v-if="!$slots.icon" :icon-name="alias" class="mr-2" />
    </template>
    <template #subtitle>
      <slot name="subtitle" />
    </template>
    <template #prefix-arrows>
      <div
        v-if="totalGames > 0"
        class="!text-primary-blue-200 font-bold text-sm"
      >
        ({{ totalGames }})
      </div>
    </template>
    <CategoryCard
      v-for="(game, index) in props.games"
      :id="game.id"
      :key="`${game.name}-${index}`"
      :image="
        props.verticalTile
          ? image(game?.image?.verticalTile || game?.tileImage)
          : image(game?.tileImage || game?.image?.squareTile)
      "
      :title="game.name"
      :subtitle="`${game.provider}`"
      :game="game"
      :vertical-tile="props.verticalTile"
      is-carousel
    />
  </UserInterfaceGenericCarousel>
</template>
